var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"app-body search"},[_c('search-container',{class:`app-body_show container-fluid pt-4 pb-5`,attrs:{"isLandscape":!!_vm.$route.meta.isLandscape}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }